var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoonIconDarkOn({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.79043 1.00659C6.09256 1.01454 6.31863 1.20371 6.42373 1.42358C6.53134 1.64879 6.53093 1.93447 6.38076 2.17407L6.38028 2.17358C6.08081 2.6529 5.95304 3.21994 6.01699 3.78149C6.08099 4.34314 6.33359 4.86664 6.7333 5.26636C7.13303 5.66601 7.65654 5.91822 8.21817 5.98218C8.77982 6.04611 9.34672 5.91801 9.82608 5.61841L9.91739 5.56909C10.135 5.47024 10.3781 5.48084 10.5756 5.57495C10.8108 5.68712 11.0097 5.93758 10.9916 6.27026C10.9395 7.23466 10.609 8.1634 10.0404 8.94409C9.47177 9.72482 8.689 10.3242 7.78701 10.6697C6.88503 11.0151 5.90211 11.092 4.95742 10.8909C4.01275 10.6897 3.14678 10.2188 2.46377 9.53589C1.78074 8.85293 1.31006 7.98693 1.10879 7.04224C0.907533 6.09752 0.984132 5.11471 1.32949 4.21265C1.67487 3.31057 2.27435 2.52798 3.05508 1.95923C3.8358 1.3905 4.76441 1.05974 5.72891 1.00757L5.79043 1.00659Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoonIconDarkOn);
export default __webpack_public_path__ + "static/media/moon-icon-dark-on.4a3f261dd3b0d31525c70c2cc148a227.svg";
export { ForwardRef as ReactComponent };